import { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

interface MobileMenuOverlayPortalProps {
  isOpen: boolean;
  withDialog: boolean;
}

const MobileMenuOverlayPortal = ({ isOpen, withDialog, children }: PropsWithChildren<MobileMenuOverlayPortalProps>) => {
  return ReactDOM.createPortal(
    <div
      className={classNames('mobile-menu-overlay', {
        'is-open': isOpen,
        'with-dialog': withDialog,
      })}
    >
      {children}
    </div>,
    document.body,
  );
};

export default MobileMenuOverlayPortal;
